module.exports = Em.Handlebars.compile("<input type=\"file\" class=\"v2-file-selector-invader-input\" {{bind-attr accept=accept multiple=multiple}}/>\n");